import { AsyncPipe, NgClass, UpperCasePipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { DividendReInvestFacade } from '@zero/shared/feature-dividend-re-invest/base';
import { ButtonComponent, CheckboxComponent, IconComponent, PillComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'shared-dividend-re-invest-hint',
  imports: [PillComponent, TranslocoPipe, UpperCasePipe, ButtonComponent, AsyncPipe, NgClass, IconComponent, CheckboxComponent],
  templateUrl: './dividend-re-invest-hint.component.html',
})
export class DividendReInvestHintComponent {
  public type = input<'home' | 'dividends'>();
  public isCheckboxChecked = false;

  public readonly facade = inject(DividendReInvestFacade);
}
